import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Card, Table, Space, Typography, notification, Select } from 'antd';
import { PlusOutlined, DeleteOutlined, SaveOutlined } from '@ant-design/icons';

const { Title } = Typography;

const Perfil = () => {
  const [form] = Form.useForm();
  const [estudios, setEstudios] = useState([]);
  const [cursos, setCursos] = useState([]);
  const [nuevoEstudio, setNuevoEstudio] = useState({ titulo: '', año: '', nivel: '' });
  const [nuevoCurso, setNuevoCurso] = useState({ nombre: '', horas: '' });

  const onFinish = (values) => {
    const datosFinales = {
      ...values,
      estudios,
      cursos,
    };
  
    // Guardar en localStorage
    localStorage.setItem('perfilDocente', JSON.stringify(datosFinales));
  
    console.log('Datos enviados:', datosFinales);
    
    notification.success({
        message: 'Datos Guardados',
        description: '✅ Tus datos han sido almacenados correctamente.',
        placement: 'topRight',
        duration: 3, // segundos
      });
  };

  useEffect(() => {
    const savedData = localStorage.getItem('perfilDocente');
    if (savedData) {
      const data = JSON.parse(savedData);
      form.setFieldsValue(data);
      setEstudios(data.estudios || []);
      setCursos(data.cursos || []);
    }
  }, [form]);
  
  const removeEstudio = (key) => {
    setEstudios(estudios.filter((item) => item.key !== key));
  };

  const removeCurso = (key) => {
    setCursos(cursos.filter((item) => item.key !== key));
  };

  const inputStyle = {
    fontSize: '16px',
    padding: '10px',
  };

  const labelStyle = {
    fontSize: '16px',
    fontWeight: 500,
  };

  return (
    <Card title="Editar Perfil del Docente" style={{ maxWidth: 800, margin: 'auto' }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          titulo: 'Mgs',
          nombre: 'Amalia',
          apellido: 'Ramirez',
          correo: 'amalia_educadora@hotmail.com',
          telefono: '0999999999',
        }}
      >
        <Form.Item
            label={<span style={labelStyle}>Título</span>}
            name="titulo"
            rules={[{ required: true, message: 'Por favor seleccione su título' }]}
        >
        <Select
            placeholder="Seleccione un título"
            style={{ width: '100%', height: 48, fontSize: '16px' }}
            options={[
            { label: 'Mgs', value: 'Mgs' },
            { label: 'Lcdo', value: 'Lcdo' },
            { label: 'Lcda', value: 'Lcda' },
            { label: 'Ing', value: 'Ing' },
            { label: 'Dr', value: 'Dr' },
            ]}
        />
        </Form.Item>
        

        <Form.Item
          label={<span style={labelStyle}>Nombre</span>}
          name="nombre"
          rules={[{ required: true, message: 'Por favor ingresa el nombre' }]}
        >
          <Input style={inputStyle} />
        </Form.Item>

        <Form.Item
          label={<span style={labelStyle}>Apellido</span>}
          name="apellido"
          rules={[{ required: true, message: 'Por favor ingresa el apellido' }]}
        >
          <Input style={inputStyle} />
        </Form.Item>

        <Form.Item
          label={<span style={labelStyle}>Correo Electrónico</span>}
          name="correo"
          rules={[
            { required: true, message: 'Por favor ingresa el correo' },
            { type: 'email', message: 'Correo inválido' },
          ]}
        >
          <Input style={inputStyle} />
        </Form.Item>

        <Form.Item
          label={<span style={labelStyle}>Teléfono</span>}
          name="telefono"
          rules={[{ required: true, message: 'Por favor ingresa el teléfono' }]}
        >
          <Input style={inputStyle} />
        </Form.Item>

        <Title level={5}>Área Académica - Estudios</Title>
        <Space style={{ marginBottom: 16 }} wrap>
            <Input
                placeholder="Título"
                value={nuevoEstudio.titulo}
                onChange={(e) => setNuevoEstudio({ ...nuevoEstudio, titulo: e.target.value })}
                style={{ width: 180, ...inputStyle }}
            />
            <Input
                placeholder="Año"
                value={nuevoEstudio.año}
                onChange={(e) => setNuevoEstudio({ ...nuevoEstudio, año: e.target.value })}
                style={{ width: 100, ...inputStyle }}
            />
            <Select
                placeholder="Selecciona nivel"
                value={nuevoEstudio.nivel}
                onChange={(value) => setNuevoEstudio({ ...nuevoEstudio, nivel: value })}
                style={{ width: 150, height: 67, ...inputStyle }}
                options={[
                    { label: 'Primaria', value: 'Primaria' },
                    { label: 'Secundaria', value: 'Secundaria' },
                    { label: '3er Nivel', value: '3er Nivel' },
                    { label: '4to Nivel', value: '4to Nivel' },
                    { label: 'PHD', value: 'PHD' },
                ]}
            />
            <Button style={{ height: 45 }} icon={<PlusOutlined />} onClick={() => {
                if (nuevoEstudio.titulo && nuevoEstudio.año && nuevoEstudio.nivel) {
                setEstudios([...estudios, { ...nuevoEstudio, key: Date.now() }]);
                setNuevoEstudio({ titulo: '', año: '', nivel: '' });
                }
            }}>
                Agregar
            </Button>
        </Space>

        <Table
            size="small"
            columns={[
                { title: 'Título', dataIndex: 'titulo', key: 'titulo' },
                { title: 'Año', dataIndex: 'año', key: 'año' },
                { title: 'Nivel', dataIndex: 'nivel', key: 'nivel' },
                {
                title: 'Acción',
                key: 'accion',
                render: (_, record) => (
                    <Button danger icon={<DeleteOutlined />} onClick={() => removeEstudio(record.key)} />
                ),
                },
            ]}
            dataSource={estudios}
            pagination={false}
        />


        <Title level={5}>Cursos Realizados</Title>
        <Space style={{ marginBottom: 16 }} wrap>
            <Input
                placeholder="Nombre del Curso"
                value={nuevoCurso.nombre}
                onChange={(e) => setNuevoCurso({ ...nuevoCurso, nombre: e.target.value })}
                style={{ width: 250, ...inputStyle }}
            />
            <Input
                placeholder="Horas"
                value={nuevoCurso.horas}
                onChange={(e) => setNuevoCurso({ ...nuevoCurso, horas: e.target.value })}
                style={{ width: 100, ...inputStyle }}
            />
            <Button style={{ height: 45 }}  icon={<PlusOutlined />} onClick={() => {
                if (nuevoCurso.nombre && nuevoCurso.horas) {
                setCursos([...cursos, { ...nuevoCurso, key: Date.now() }]);
                setNuevoCurso({ nombre: '', horas: '' });
                }
            }}>
                Agregar
            </Button>
        </Space>

        <Table
            size="small"
            columns={[
                { title: 'Curso', dataIndex: 'nombre', key: 'nombre' },
                { title: 'Horas', dataIndex: 'horas', key: 'horas' },
                {
                title: 'Acción',
                key: 'accion',
                render: (_, record) => (
                    <Button danger icon={<DeleteOutlined />} onClick={() => removeCurso(record.key)} />
                ),
                },
            ]}
            dataSource={cursos}
            pagination={false}
        />


        <Form.Item style={{ marginTop: 32 }}>
          <Button type="primary" htmlType="submit" icon={<SaveOutlined />} block>
            Guardar Cambios
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default Perfil;
